/**
 * 权限指令
 * 使用方式：v-permission="'user:add'" 或 v-permission="['user:add', 'user:edit']"
 */
import { hasPermission, hasRole } from '@/utils/auth'

export default {
  // 插入元素时
  inserted(el, binding) {
    const { value } = binding
    
    if (!value) {
      return
    }
    
    // 判断是否有权限
    const hasAuth = hasPermission(value)
    
    if (!hasAuth) {
      // 如果没有权限，则移除元素
      el.parentNode && el.parentNode.removeChild(el)
    }
  }
}

/**
 * 角色指令
 * 使用方式：v-role="'admin'" 或 v-role="['admin', 'manager']"
 */
export const role = {
  inserted(el, binding) {
    const { value } = binding
    
    if (!value) {
      return
    }
    
    // 判断是否有角色
    const hasAuth = hasRole(value)
    
    if (!hasAuth) {
      // 如果没有角色权限，则移除元素
      el.parentNode && el.parentNode.removeChild(el)
    }
  }
} 